import classes from './serviceAccountDetailsComponent.scss';
const ServiceAccountDetailsComponent = (props) => {
  let details = props.selectedAccount;
  let contractNumber = details.contractNumber;
  let houseNumber = details.houseNumber;
  let strAddress = (details.streetAddress).toLowerCase();
  let city = (details.city).toLowerCase();
  let state = (details.state);
  let zipCode = (details.zipcode);
  let serviceAddress = houseNumber + " " + (details.streetAddress).toUpperCase() + " " + (details.city).toUpperCase() + " " + state + " " + zipCode;
  const serviceAccountDetailsJSX = <div className={classes.sceServiceAccInfoOuter}>
  {(details.houseNumber!=="" && details.streetAddress!=="") ? 
  <div className={classes.sceServiceAccInfo}>
  <div className={classes.serviceAccountDetails}><span className={classes.actInfo}> {details.houseNumber} {strAddress}, {city},  {details.state} {details.zipCode}</span>&nbsp;<span className={classes.accountData}>{" - Acct. "} {contractNumber}</span>
  </div>
  </div> 
  :
  <div className={classes.sceServiceAccInfo}>
     <div className={classes.serviceAccountDetails}>
     <span className={classes.actInfo}>{city},  {details.state} {details.zipCode}</span>&nbsp;
     <span className={classes.accountData}>{" - Acct.  "} {contractNumber}</span>
 </div>
 </div>
  }
 </div>;

  return (
    <div>
      {serviceAccountDetailsJSX}
    </div>
  );

};


export default ServiceAccountDetailsComponent;
